import { IPaginatedRequest } from '../../../request'
import { NewExternalSystem } from './index'

export const getExternalSystems = (companyUUID: string, shopId: string, params: IPaginatedRequest) => ({
  url: `/modules/companies/${companyUUID}/shops/${shopId}/external-systems`,
  method: 'GET',
  params
})

export const getExternalSystem = (companyUUID: string, shopId: string, systemUUID: string) => ({
  url: `/modules/companies/${companyUUID}/shops/${shopId}/external-systems/${systemUUID}`,
  method: 'GET'
})

export const createExternalSystem = (companyUUID: string, shopId: string, data: NewExternalSystem) => ({
  url: `/modules/companies/${companyUUID}/shops/${shopId}/external-systems`,
  method: 'POST',
  data
})

export const updateExternalSystem = (companyUUID: string, shopId: string, systemUUID: string, data: NewExternalSystem) => ({
  url: `/modules/companies/${companyUUID}/shops/${shopId}/external-systems/${systemUUID}`,
  method: 'PUT',
  data
})

export const deleteExternalSystem = (companyUUID: string, shopId: string, systemUUID: string, dryRun: boolean) => ({
  url: `/modules/companies/${companyUUID}/shops/${shopId}/external-systems/${systemUUID}`,
  method: 'DELETE',
  params: {
    DryRun: dryRun
  }
})

export const getExternalSystemValues = () => ({
  url: '/modules/external-systems',
  method: 'GET'
})
